import React, { useEffect, useMemo } from 'react';
import { Table } from 'js/components/common/Table';
import { pick, compose } from 'js/utils/ramda.util';
import { useEffectOnce } from 'js/hooks/useEffectOnce';
import { withComponent } from 'js/components/hocs/withComponent';
import { componentService } from 'js/services/component.service';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import * as hooks from './hooks';
import * as helpers from './helpers';
import * as actions from './store/actions';
import { LAST_24_HOURS_VALUE } from './constants';
import { withDynamicReducer, useDynamicReducerSelector, useDynamicReducerDispatch } from './store';

import style from './ResponsibleGamingHistory.scss';

const ResponsibleGamingHistoryBare = () => {
    const dispatch = useDynamicReducerDispatch();
    const translate = useComponentTranslations();
    const { error, isLoading } = useDynamicReducerSelector(pick(['error', 'isLoading']));
    const tableData = hooks.useTableData();
    const fetchComponentConfig = hooks.useFetchComponentConfig();
    const fetchPlayerGamblingHistory = hooks.useFetchPlayerGamblingHistory();
    const {
        filters,
        headerValidate,
        anotherPeriodFilter,
        headerInitialValues,
        onAnotherPeriodApply
    } = hooks.useTableHeader();
    const classNames = useMemo(() => ({
        tableBodyRowColumn: style.tableBodyRowColumn,
        tableHeaderRowColumn: style.tableHeaderRowColumn
    }), []);

    useEffect(() => {
        fetchComponentConfig();
    }, [fetchComponentConfig]);

    useEffect(() => {
        fetchPlayerGamblingHistory();
    }, [fetchPlayerGamblingHistory]);

    useEffectOnce(() => {
        dispatch(actions.updateStartDate(helpers.getStartDate(LAST_24_HOURS_VALUE)));
    }, [dispatch]);

    return (
        <Table
            error={error}
            filters={filters}
            isLoading={isLoading}
            tableData={tableData}
            classNames={classNames}
            headerValidate={headerValidate}
            showTableBody={Boolean(!error)}
            emptyTitle={translate('table.empty')}
            headerInitialValues={headerInitialValues}
            anotherPeriodFilter={anotherPeriodFilter}
            onAnotherPeriodApply={onAnotherPeriodApply}
        />
    );
};

export const ResponsibleGamingHistory = compose(
    withComponent({
        isForLoggedIn: true,
        tkPrefix: 'playtech.mobile.system.responsibleGamingHistory.'
    }),
    withDynamicReducer()
)(ResponsibleGamingHistoryBare);

componentService.registerWebContentComponents({ ResponsibleGamingHistory });
